import { isPriceHidden } from "~/utils/account/isPriceHidden";

/** Price gate for gated B2B. Rule and rationale in {@link isPriceHidden}. */
export const usePriceVisibility = () => {
	const {
		public: {
			norce: { b2bAccess }
		}
	} = useRuntimeConfig();
	const { getUser } = storeToRefs(userStore());
	const isHydrated = ref(false);

	onMounted(() => {
		isHydrated.value = true;
	});

	return {
		b2bAccess,
		isPriceHidden: computed(() =>
			isPriceHidden({
				b2bAccess,
				isHydrated: isHydrated.value,
				hasUser: Boolean(getUser.value)
			})
		)
	};
};
